import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

interface MobileCardListSkeletonProps {
  columnsCount?: number;
  rowsCount?: number;
}

const DEFAULT_COLUMNS_COUNT = 5;
const DEFAULT_ROWS_COUNT = 5;

export const MobileCardListSkeleton = ({
  columnsCount = DEFAULT_COLUMNS_COUNT,
  rowsCount = DEFAULT_ROWS_COUNT,
}: MobileCardListSkeletonProps): React.ReactElement => (
  <div className="flex flex-col gap-3 am-lg:hidden">
    {Array.from({ length: rowsCount }).map((_, index) => (
      <div key={index} className="rounded-md border shadow bg-white px-4 py-3">
        {Array.from({ length: columnsCount }).map((_, columnIndex) => (
          <div
            key={columnIndex}
            className="flex justify-between items-center gap-2 py-2 border-b last:border-0"
          >
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-4 w-1/4" />
          </div>
        ))}
      </div>
    ))}
  </div>
);
